export var CellType;
(function (CellType) {
    CellType[CellType["empty"] = 0] = "empty";
    CellType[CellType["mine"] = 1] = "mine";
    CellType[CellType["count"] = 2] = "count";
})(CellType || (CellType = {}));
export var CellClickState;
(function (CellClickState) {
    CellClickState[CellClickState["clicked"] = 0] = "clicked";
    CellClickState[CellClickState["not_clicked"] = 1] = "not_clicked";
})(CellClickState || (CellClickState = {}));
export var CellSymbols;
(function (CellSymbols) {
    CellSymbols["mine"] = "\uD83D\uDCA3";
    CellSymbols["flag"] = "\uD83D\uDEA9";
    CellSymbols["empty"] = "";
    CellSymbols["explode"] = "\uD83D\uDCA5";
})(CellSymbols || (CellSymbols = {}));
export var FlagState;
(function (FlagState) {
    FlagState[FlagState["flagged"] = 0] = "flagged";
    FlagState[FlagState["not_flagged"] = 1] = "not_flagged";
})(FlagState || (FlagState = {}));
export var ClickType;
(function (ClickType) {
    ClickType[ClickType["left"] = 0] = "left";
    ClickType[ClickType["right"] = 2] = "right";
})(ClickType || (ClickType = {}));
export var GameState;
(function (GameState) {
    GameState[GameState["on"] = 0] = "on";
    GameState[GameState["win"] = 1] = "win";
    GameState[GameState["lose"] = 2] = "lose";
})(GameState || (GameState = {}));
export const GameDifficulty = {
    baby: { rows: 5, cols: 5, mines: 2, cellSize: "40px" },
    normal: { rows: 9, cols: 9, mines: 10, cellSize: "30px" },
    expert: { rows: 16, cols: 16, mines: 40, cellSize: "27px" },
    "cheat with an AI": { rows: 16, cols: 46, mines: 180, cellSize: "25px" }, // 25% covered with mines - u need to be only lucky to beat this
};
